<div id="new-regimen-banner" class="font-noto tw-flex tw-justify-center tw-flex-col tw-rounded-[15px] tw-overflow-hidden" (click)="buyRegimen(regimen.class)">
  <ng-container *ngIf="showMoneyBackGuaranteeBanner">
    <div class="tw-bg-gradient-black-to-light-black tw-py-0.5 tw-font-lexend tw-flex tw-justify-center tw-items-center tw-text-100">
        <span class="tw-text-[#c7b189] tw-inline-block">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="tw-w-[7px] tw-h-[7px]">
            <path d="M12 2 L14.95 8.6 L22 9.3 L16.8 14.2 L18.3 22 L12 18.3 L5.7 22 L7.2 14.2 L2 9.3 L9.05 8.6 Z" />
          </svg>
        </span>
      <span class="tw-text-[#c7b189] tw-inline-block tw-mr-1 tw-ml-0.5">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="tw-w-2.5 tw-h-2.5">
            <path d="M12 2 L14.95 8.6 L22 9.3 L16.8 14.2 L18.3 22 L12 18.3 L5.7 22 L7.2 14.2 L2 9.3 L9.05 8.6 Z" />
          </svg>
        </span>
      <p class="tw-text-gray-50 tw-mr-1">100%</p>
      <p class="tw-font-bold tw-text-gray-50 tw-mr-1" i18n="@@moneyBack">MONEY BACK</p>
      <p class="tw-font-bold money-back-guarantee-gradient-text tw-uppercase" i18n="@@guarantee">guarantee</p>
      <span class="tw-text-[#c7b189] tw-inline-block tw-ml-1 tw-mr-0.5">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="tw-w-2.5 tw-h-2.5">
            <path d="M12 2 L14.95 8.6 L22 9.3 L16.8 14.2 L18.3 22 L12 18.3 L5.7 22 L7.2 14.2 L2 9.3 L9.05 8.6 Z" />
          </svg>
        </span>
      <span class="tw-text-[#c7b189] tw-inline-block">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="tw-w-[7px] tw-h-[7px]">
            <path d="M12 2 L14.95 8.6 L22 9.3 L16.8 14.2 L18.3 22 L12 18.3 L5.7 22 L7.2 14.2 L2 9.3 L9.05 8.6 Z" />
          </svg>
        </span>
    </div>
  </ng-container>
  <div [ngClass]="regimenImageBackgroundColor">
    <img id="cover-image" class="tw-w-full tw-rounded-[15px] max-h-[82px] tw-object-cover" alt="Products" [src]="coverImage" />
  </div>
  <div class="tw-flex tw-items-center tw-text-center tw-flex-col -tw-mt-14 tw-pt-12 tw-pb-5 tw-bg-white tw-relative tw-rounded-b-[15px]">
    <img id="doctor-image" class="tw-rounded-full tw-w-[93px] tw-object-cover tw-h-[93px] tw-absolute -tw-top-12 tw-left-1/2 -tw-translate-x-1/2" [src]="doctorImage || 'https://cdn.cureskin.com/app/img/regimen_banner_doctor.png'" alt="Doctor" style="border: 3px solid white" />
    <p id="hair-message-with-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-10" *ngIf="class === appConfig.Shared.Regimen.Class.HAIR && concernDisplayName">
      <span class="tw-capitalize tw-font-bold">{{userName}},&nbsp;</span>
      <span i18n="@@treatmentKitIsReadyWithConcern">
            <span class="tw-font-bold">your treatment kit </span>for {{ concernDisplayName }} is ready
          </span>
    </p>
    <p id="hair-message-without-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-8 tw-font-bold" *ngIf="class === appConfig.Shared.Regimen.Class.HAIR && !concernDisplayName">
      <span class="tw-capitalize">{{userName}},&nbsp;</span><span i18n="@@yourHairKitIsReady" class="tw-lowercase">Your hair treatment kit is ready</span>
    </p>
    <p id="face-message-with-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-10" *ngIf="class === appConfig.Shared.Regimen.Class.FACE && concernDisplayName">
      <span class="tw-capitalize tw-font-bold">{{userName}},&nbsp;</span>
      <span i18n="@@treatmentKitIsReadyWithConcern">
            <span class="tw-font-bold">your treatment kit </span>for {{ concernDisplayName }} is ready
          </span>
    </p>
    <p id="face-message-without-concern" class="tw-mt-2 tw-text-400 tw-text-gray-800 tw-mb-3 tw-px-8 tw-font-bold" *ngIf="class === appConfig.Shared.Regimen.Class.FACE && !concernDisplayName">
      <span class="tw-capitalize">{{userName}},&nbsp;</span><span i18n="@@yourSkinKitIsReady" class="tw-lowercase">Your skin treatment kit is ready</span>
    </p>
    <div class="tw-w-fit tw-flex tw-items-center tw-gap-3">
      @if(showDoubleCta) {
        <span class="tw-text-teal-600 tw-bg-white tw-border tw-border-teal-600 tw-py-[7px] tw-px-[22px] tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden" i18n="@@howToUse" (click)="seeInstructions()"> How to use </span>
      }
      <span i18n="@@buyNow" class="tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">Buy Now</span>
    </div>
  </div>
</div>
